<div class="h-[6.25rem] w-[6.25rem]">
  <svg viewBox="0 0 36 36" [attr.class]="'circular-chart green'">
    <path
      class="stroke-3.8 fill-none stroke-white"
      d="M18 2.0845
        a 15.9155 15.9155 0 0 1 0 31.831
        a 15.9155 15.9155 0 0 1 0 -31.831"
    />
    <path
      class="circle {{ strokeColor }}"
      [attr.stroke-dasharray]="strokes"
      d="M18 2.0845
        a 15.9155 15.9155 0 0 1 0 31.831
        a 15.9155 15.9155 0 0 1 0 -31.831"
    />
    <text x="18" y="20.35" class="percentage font-bold">{{ value }}%</text>
  </svg>
</div>
